import { render, staticRenderFns } from "./ProdictConfigEdit.vue?vue&type=template&id=13701c88&"
import script from "./ProdictConfigEdit.vue?vue&type=script&lang=js&"
export * from "./ProdictConfigEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports